import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

/**
 * Donut chart for top/bottom 5 products sold (data from dashboard API).
 * @param {{ title: string, data: Array<{ product_id: number, title: string, sku: string, sold: number }> }} props
 */
const ProductsSoldDonut = ({ title, data = [] }) => {
  const chartState = useMemo(() => {
    const labels = data.map((item) => item.title || item.sku || `#${item.product_id}`);
    const series = data.map((item) => Number(item.sold) || 0);
    const sum = series.reduce((a, b) => a + b, 0);
    return {
      series,
      options: {
        chart: {
          type: "donut",
          height: 280,
        },
        labels,
        legend: {
          position: "bottom",
          fontSize: "12px",
          fontFamily: "Poppins",
          labels: {
            colors: "#3E4954",
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => (sum > 0 ? `${Number(val).toFixed(0)}%` : "0%"),
        },
        plotOptions: {
          pie: {
            donut: {
              size: "55%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total Sold",
                  formatter: () => (sum > 0 ? sum : "0"),
                },
              },
            },
          },
        },
        colors: [
          "var(--primary)",
          "var(--secondary)",
          "#1EA7C5",
          "#FF9432",
          "#6c5ce7",
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { height: 240 },
            },
          },
        ],
      },
    };
  }, [data]);

  if (!data || data.length === 0) {
    return (
      <div className="d-flex align-items-center justify-content-center text-muted py-4">
        <span>No data</span>
      </div>
    );
  }

  return (
    <div>
      <ReactApexChart
        options={chartState.options}
        series={chartState.series}
        type="donut"
        height={280}
      />
    </div>
  );
};

export default ProductsSoldDonut;
